import * as rq from '@tanstack/react-query';

import { useDependencies } from '../../contexts/dependencies.context';
import type { SitePreviewExtended } from '../../domain/entities/site';

export namespace GetAllSitesExtended {
  export const key = () => ['get-all-sites-extended'];

  export type Params = { refetchInterval?: number };
  export type Output = SitePreviewExtended[];

  export function useQuery({ refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(),
      queryFn: () => repositories.site.getAllExtended(),
    });
  }
}
